<template>
  <div class="login">
    <Head /><Kefu />
    <div class="tip">Ingresá a tu cuenta</div>
    <van-form @submit="submitForm" :show-error="false" label-align="center" ref="form">
      <van-field
        v-model="params.username"
        maxlength="20"
        placeholder="Document"
        :rules="rules.username"
        clearable
        name="username"
      >
      </van-field>
      <van-field
        v-model="params.password"
        type="password"
        maxlength="20"
        placeholder="Password"
        :rules="rules.password"
        clearable
      />
      <!-- <van-checkbox class="register-checkbox" v-model="params.policy" label-disabled
        >同意
        <router-link to="/policy" :style="{ color: $bus.style.blueColor }"
          >《用户协议与隐私政策》</router-link
        >
      </van-checkbox> -->
      <div class="login-button">
        <van-button round block color="#7832b0" native-type="submit" :loading="state.loginBtn"
          >Enter</van-button
        >
      </div>
      <div style="color: #7832b0" @click="$router.push('/Forget')">Forgot your password?</div>
      <div class="tip" style="font-weight: 500; margin-top: 20px">Don't you realize?</div>
      <div class="login-button" @click="$router.push('/register')">
        <van-button round block color="#7832b0">Create Account</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
const VERSION = require('_r/package.json').version
import Store from '@/store'
export default {
  data() {
    return {
      params: {
        username: '',
        password: '',
        policy: false
      },
      rules: {
        username: [{ required: true, message: 'Enter your document' }],
        password: [{ required: true, message: 'Enter your password' }]
      },
      state: {
        time: 60,
        loginBtn: false,
        codeBtn: false,
        interval: null
      }
    }
  },
  methods: {
    async submitForm() {
      const { policy, ...params } = this.params
      // 更改按钮状态节流
      this.state.loginBtn = true
      Object.assign(params, {
        terminalModel: this.$bus.model,
        osVersion: this.$bus.system,
        appVersion: VERSION
      })
      // 登录
      const res = await this.$request.login(params)
      if (res.retCode === '000') {
        Store.commit('SET_USERINFO', res.result.username)
        let path = this.$route.query.path || '/'
        let state = res.result.state
        if (state === 1) {
          path = '/result'
        }
        if (state === 2) {
          path = '/upload'
        }
        this.$router.push(path)
      } else {
        this.$toast.fail('The account does not exist')
        this.state.loginBtn = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
.login {
  min-height: 100vh;
  background-color: #fff;
  text-align: center;
  .van-form {
    padding-top: 10px;
    margin-left: 40px;
    overflow: hidden;
    :deep(.van-field__label) {
      width: 32px;
    }
    .van-cell.van-field {
      padding-top: 24px;
      padding-bottom: 5px;
      .van-field__label {
        .van-icon {
          top: 3px;
        }
      }
    }
  }
  :deep(.van-field__right-icon) {
    font-size: 15px;
  }
  &-code__btn {
    font-size: 15px;
  }
  &-button {
    margin: 20px 16px 16px;
    width: 264px;
  }
  .van-checkbox {
    margin: 30px 24px;
  }
  :deep(.van-checkbox__label) {
    color: #666;
    a {
      color: #333;
    }
  }
}
.tip {
  margin-top: 80px;
  font-weight: bold;
  color: #7832b0;
  font-size: 25px;
}
</style>
